var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atoms/icons/e.badge.universal.status",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,2 C19.1045695,2 20,2.8954305 20,4 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L18,2 Z M15,18 L9,18 L9,19 L15,19 L15,18 Z M17,15 L17,16 L7,16 L7,15 L17,15 Z M10.23,5 L10.23,9.328 C10.23,9.56 10.25,9.788 10.29,10.012 C10.33,10.236 10.414,10.434 10.542,10.606 C10.67,10.778 10.848,10.918 11.076,11.026 C11.304,11.134 11.61,11.188 11.994,11.188 C12.666,11.188 13.13,11.038 13.386,10.738 C13.642,10.438 13.77,9.968 13.77,9.328 L13.77,9.328 L13.77,5 L15.654,5 L15.654,9.328 C15.654,10.488 15.33,11.35 14.682,11.914 C14.034,12.478 13.138,12.76 11.994,12.76 C10.834,12.76 9.936,12.48 9.3,11.92 C8.664,11.36 8.346,10.496 8.346,9.328 L8.346,9.328 L8.346,5 L10.23,5 Z",
    id: "Universal",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#FFFFFF",
    cx: 5.5,
    cy: 5.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "atoms/icons/check",
    fill: "#00346B"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "7.9387254 3.20833333 8.58690662 3.85651455 4.85350585 7.58991532 2.75 5.48640948 3.39818122 4.83822826 4.85334061 6.29342394"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5ef06e39a548ad8bde21841c4ca8584c.svg";
export { ForwardRef as ReactComponent };